import { Grid, useMediaQuery } from '@material-ui/core';
import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import formatters from '../../../../Core/Grid/inputFormatter';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add, Edit } from '@material-ui/icons';
import ReactDOM from 'react-dom';
import AddLocationDetails from './addLocationDetails';
import DialogComp from '../../../../Core/Modal/dialogModal';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Sales', active: true },
    { name: 'Location Details', active: true }
];

const baseColumns = [
    { field: 'action', title: `Action`, width: '5%', filterable: false, sortable: false },
    { field: 'locationDetailCode', title: `Code`, sortable: true, width: '5%' },
    { field: 'locationDetailName', title: `Name`, filterable: true, sortable: true, width: '6%' },
    { field: 'address', title: `Address`, filterable: true, sortable: true },
    { field: 'locationDetailPhone', title: `Phone`, filterable: true, sortable: true, width: '8%' },
    { field: 'locationDetailEmail', title: `Email`, filterable: true, sortable: true, width: '10%' },
    { field: 'locationDetailContactName', title: `Contact Name`, filterable: true, sortable: true, width: '10%' },
    { field: 'locationDetailContactEmail', title: `Contact Email`, filterable: true, sortable: true, width: '10%' },
    { field: 'locationDetailContactPhone', title: `Contact Phone`, filterable: true, sortable: true, width: '10%' }
];

const SalesLocationDetails = (props) => {
    const [state, setState] = useState({
        showModal: false,
        locationDetails: {},
        activeSelected: true,
        isReload: null
    });

    const showAddLocation = () => {
        setState((prev) => ({ ...prev, showModal: true, locationDetails: {} }));
    };
    const showEditLocation = (row) => {
        setState((prev) => ({ ...prev, showModal: true, locationDetails: row }));
    };
    const hideLocationDetails = (res) => {
        setState((prev) => ({ ...prev, showModal: false, locationDetails: {} }));
        res && setState((prev) => ({ ...prev, isReload: Date.now() }));
    };

    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="flex-start" style={{ width: '100%' }}>
                <abbr title="Add Location Details">
                    <SquareButton
                        style={{
                            backgroundColor: '#183B68',
                            borderRadius: '20%',
                            width: '32px',
                            height: '32px',
                            textAlign: 'center',
                            padding: '0px 0px 0px 0px',
                            marginLeft: '11px'
                        }}
                        onClick={showAddLocation}
                    >
                        <Add fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = (row, data) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="flex-start" style={{ width: '100%' }}>
                <abbr title="Edit Driver Rates">
                    <SquareButton
                        style={{
                            backgroundColor: '#183B68',
                            borderRadius: '20%',
                            width: '32px',
                            height: '32px',
                            textAlign: 'left',
                            padding: '0px 0px 0px 0px'
                        }}
                        onClick={() => showEditLocation(data)}
                    >
                        <Edit fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const addressCol = (row, data) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="flex-start" style={{ width: '100%' }}>
                <Grid
                    item
                >{`${data.locationDetailAddressLine1} ${data.locationDetailAddressLine2} ${data.locationDetailTown} ${data.locationDetailCounty} ${data.locationDetailPostCode} ${data.locationDetailCountry}`}</Grid>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((k) => k.field === 'action');
        let adCol = tempCols.find((k) => k.field === 'address');
        if (actionCol) actionCol.renderer = editButton;
        if (adCol) adCol.renderer = addressCol;
        return tempCols;
    }, []);

    const baseUrl = `LocationDetails`;

    return (
        <div>
            <div className="report-screen-container">
                <Grid container justify="space-between">
                    <Grid item>
                        <BreadCrumbs crumbs={crumbs} />
                    </Grid>
                </Grid>
                <Grid item container spacing={1} xs={12}>
                    <Grid item xs={12}>
                        <ReportGijgoGrid
                            dataConverter={(res) => ({
                                records: res?.data?.list,
                                total: res?.data?.total
                            })}
                            columns={columns}
                            getUrl={baseUrl}
                            AddBtn={addButton}
                            isReload={state.isReload}
                        />
                    </Grid>
                    {state.showModal ? (
                        <DialogComp
                            title={state?.locationDetails?.locationDetailID ? 'Update Location' : 'Add Location'}
                            maxWidth="md"
                            onClose={hideLocationDetails}
                        >
                            <AddLocationDetails rowID={state?.locationDetails?.locationDetailID} row={state.locationDetails} onClose={hideLocationDetails} />
                        </DialogComp>
                    ) : null}
                </Grid>
            </div>
        </div>
    );
};

export default SalesLocationDetails;
